<div>
    <div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
        <p class="text-muted">RISIKOVURDERING <i class="fa fa-chevron-right"></i></p>
        <h2 i18n>Søg lokalitet</h2>
        <p i18n>Start med at finde lokaliteten du ønsker at risikovurdere</p>
        </div>
    </div>
    </div>
    <div class="container">
        <div class="row mt-4">

            <div class="col-sm-12 col-lg-12">
            <h4 class="search-call-to-attention vd-fade fast" [ngClass]="{'out': !initialSearch, 'in': initialSearch}">Start
                din søgning</h4>
            <div>
                <div style="    float: right;
            margin-bottom: 1rem;">
                <button class="btn btn-secondary mr-2" [routerLink]="!isExternalUser ? '/riskassessment/search' : '/riskassessment/external-location-overview'">Risikovurdering efter lokation</button>
                </div>
                <div class="vd-main-search-bar no-searchresults" [ngClass]="{'no-searchresults': initialSearch}">
                    <input type="text" id="searchInput" [(ngModel)]="searchText" (keyup)="onInputChanged()"
                        [disabled]="isSearching"
                        aria-describedby="searchinput" placeholder="Søg efter lokalitetsnavn eller nummer (f.eks. 671-00281)...">
                    <div>
                        <span [ngClass]="{'in': isSearching, 'out': !isSearching}" class="vd-fade" style="margin-top: 2px"><i class="fa fa-circle-o-notch fa-spin fa-lg mr-3"></i></span>
                        <button class="btn btn-secondary" [disabled]="isSearching" (click)="onClickSearchButton()">SØG <i class="fa fa-search"></i></button>
                    </div>
                </div>

                <div *ngIf="!initialSearch">
                    <div class="btn-group mt-3">
                        <!-- <div class=""><span class="text-muted">Filtre:</span></div> -->
                        <div class="dropdown">
                        <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{statusFilter?statusFilter.text:"Vælg Risikovurdering"}}
                        </a>

                        <div class="dropdown-menu">
                            <a *ngFor="let filter of statusFilters" class="dropdown-item"
                            (click)="statusFilter=filter;refreshSearch()">
                            <span class="fa-stack risk-indicator"
                                [ngClass]="{'risk-computed':(filter.status==riskAssessmentStatusEnum.Risk && filter.calculationType != highestRiskCalculationTypeEnum.Screening), 
                                    'risk-screening':(filter.status==riskAssessmentStatusEnum.Risk && filter.calculationType == highestRiskCalculationTypeEnum.Screening), 
                                    'no-risk-computed':(filter.status==riskAssessmentStatusEnum.NoRisk && filter.calculationType != highestRiskCalculationTypeEnum.Screening), 
                                    'no-risk-screening':(filter.status==riskAssessmentStatusEnum.NoRisk && filter.calculationType == highestRiskCalculationTypeEnum.Screening)}">
                                <span class="icon"></span>
                            </span>
                            {{filter.text}}
                            </a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" (click)="statusFilter=null;refreshSearch()">Vis alle</a>
                        </div>
                        </div>

                        <div *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations" 
                            class="form-control search-case-worker text-input sub-input ml-3">
                            <input [(ngModel)]="caseWorkerName" (ngModelChange)="filterCaseWorker($event);"
                                [matAutocomplete]="caseWorkerAutoComplete" name="caseWorker" type="text" class="text-input"
                                placeholder="Vælg sagsbehandler " required />

                            <mat-autocomplete #caseWorkerAutoComplete="matAutocomplete" (optionSelected)="refreshSearch()" panelWidth="auto"
                                autoActiveFirstOption>
                                <mat-option *ngFor="let caseWorker of filteredCaseWorkers" [value]="caseWorker.name" class="case-worker-option">
                                    <i class="fa fa-user fa-lg"></i> {{ caseWorker.name }}
                                </mat-option>
                                <div class="dropdown-divider"></div>
                                <mat-option class="dropdown-item case-worker-option all-case-woker" (click)="filteredCaseWorkers=caseWorkers;refreshSearch()"><i class="fa fa-users fa-lg"></i> Vis alle</mat-option>
                            </mat-autocomplete>
                        </div>

                        <div class="form-control text-input sub-input ml-3">
                        <span class="mr-1">Faktor fra:</span>
                        <input type="number" [(ngModel)]="minFactor" (focusout)="refreshSearch();">
                        </div>

                        <div class="form-control text-input sub-input ml-1">
                        <span class="mr-1">Faktor til:</span>
                        <input type="number" [(ngModel)]="maxFactor" (focusout)="refreshSearch();">
                        </div>

                    </div>
                </div>
            </div>
            </div>
        </div>

        <div class="row mt-4">
            <div *ngIf="!isSearching && allSearchResults != null && (allSearchResults?.length < 1)"
            class="col-sm-12 col-lg-12 mb-5 mt-3 text-center">
                <img style="width:8rem" src="assets/undraw_no_data_qbuo.svg">
                <p class="text-muted mt-3" i18n>Der blev desværre ikke fundet nogen risikovurdering ...</p>
            </div>

            <div [ngClass]="{'in': displaySearchResults, 'out': !displaySearchResults}"
            class="col-sm-12 col-lg-12 mb-5 vd-fade">
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <!-- location -->
                    <th (click)="setOrderBy(riskCalculationSearchOrder.LocationNumber)">Lokalitetsnr.</th>
                    <th (click)="setOrderBy(riskCalculationSearchOrder.LocationName)">Navn</th>
                    <th>Region</th>

                    <!-- Calculation -->
                    <th (click)="setOrderBy(riskCalculationSearchOrder.Factor)">Overskridelsesfaktor</th>
                    <!-- calculationModel(Model1-5) -->
                    <th (click)="setOrderBy(riskCalculationSearchOrder.CalculationModelType)">Beregningsmodel</th>
                    <!-- Status (approved/approved) - Type -->
                    <th (click)="setOrderBy(riskCalculationSearchOrder.Status)">Status</th>
                    <!-- RiskAssessment -->
                    <th (click)="setOrderBy(riskCalculationSearchOrder.RiskAssessment)">Risikovurdering</th>
                    <th (click)="setOrderBy(riskCalculationSearchOrder.CreatedAt)">Date</th>
                    <!-- case worker -->
                    <th *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations" 
                        (click)="setOrderBy(riskCalculationSearchOrder.CaseWorkerName)">
                        Sagsbehandler
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let location of allSearchResults"
                    [routerLink]="['/riskassessment/calculation-result', location.id]">
                    <td>{{location.number}}</td>
                    <td>{{location.name}}</td>
                    <td>{{location.region}}</td>

                    <ng-container *ngIf="location.calculationFailed">
                        <td colspan="4" class="text-danger">
                            <div class="alert alert-danger m-0 p-1" role="alert">
                                <b><i class="fa fa-exclamation fa-lg"></i>Beregningen fejlede:</b>
                                {{location.calculationFailedErrorMessage}}
                            </div>
                            <!-- <i class="fa fa-exclamation-triangle"></i>
                            Beregning mislykkedes: {{location.calculationFailedErrorMessage}} -->
                        </td>
                        
                        <td class="text-muted">{{location.calculationDate | date:'d/M/yyyy HH:mm'}}</td>

                        <td>
                            <span *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations && isScreening(location)" class="text-muted">
                                <i class="fa fa-cog"></i>
                                <span *ngIf="location.caseWorker"> {{location.caseWorker?.name}} (Omdømt)</span>
                                <span *ngIf="!location.caseWorker"> Automatisk screening</span>
                            </span>
                            <span *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations && !isScreening(location) && location.caseWorker">
                                <i class="fa fa-user"></i> {{location.caseWorker?.name}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container *ngIf="!location.calculationFailed">
                        <!-- Calculation -->
                        <td>
                            <span *ngIf="location.excessFactor">
                                <span [ngSwitch]="location.riskAssessment">
                                <span
                                    *ngSwitchCase="riskAssessmentStatusEnum.Risk"><b>{{getValidNumber(location.excessFactor) | number:'1.0-1'}}</b></span>
                                <span
                                    *ngSwitchCase="riskAssessmentStatusEnum.NoRisk">{{getValidNumber(location.excessFactor) | number:'1.0-1'}}</span>
                                </span>
                                <span *ngIf="isScreening(location)" class="text-muted"> (screeningsresultat)</span>
                            </span>
                            <span *ngIf="!location.excessFactor">0</span>
                        </td>

                        <!-- calculationModel(Model1-5) -->
                        <td>
                            <!-- <div _ngcontent-yqd-c99="" class="readonly">
                                <span _ngcontent-yqd-c99="" class="model-indicator">
                                    <i _ngcontent-yqd-c99="" class="model-icon"></i>
                                    <span _ngcontent-yqd-c99="" class="model-number">5</span>
                                </span> Forureningskilde beliggende lige over grundvandet 
                            </div> -->
                            <div class="readonly">
                                <span class="model-indicator">
                                    <i class="model-icon"></i>
                                    <span class="model-number">{{location?.calculationModelType}}</span>
                                </span>
                                {{calculationModelNamesEnum[location?.calculationModelType] ? calculationModelNamesEnum[location?.calculationModelType] : ''}}
                            </div>
                        </td>
                        
                        <!-- Status (approved/approved) - Type -->
                        <td>
                            <!-- Godkendte risikoberegninger -->
                            {{ statusTextMap[location.status] || '-' }}
                        </td>

                        <!-- RiskAssessment -->
                        <td style="white-space: nowrap;">
                            <!-- <span *ngIf="location.calculationType != highestRiskCalculationTypeEnum.None">
                                <span class="fa-stack risk-indicator"
                                [ngClass]="{'risk-computed':(location.riskAssessmentStatus==riskAssessmentStatusEnum.Risk && location.calculationType != highestRiskCalculationTypeEnum.Screening), 'risk-screening':(location.riskAssessmentStatus==riskAssessmentStatusEnum.Risk && location.calculationType == highestRiskCalculationTypeEnum.Screening), 'no-risk-computed':(location.riskAssessmentStatus==riskAssessmentStatusEnum.NoRisk && location.calculationType != highestRiskCalculationTypeEnum.Screening), 'no-risk-screening':(location.riskAssessmentStatus==riskAssessmentStatusEnum.NoRisk && location.calculationType == highestRiskCalculationTypeEnum.Screening)}">

                                </span>
                                <span [ngSwitch]="location.riskAssessmentStatus" style="vertical-align: text-bottom;">
                                <span *ngSwitchCase="riskAssessmentStatusEnum.Risk"><b>Risiko</b></span>
                                <span *ngSwitchCase="riskAssessmentStatusEnum.NoRisk">Ingen risiko</span>
                                </span>
                            </span> -->
                            <span class="fa-stack risk-indicator"
                                [ngClass]="{'risk-computed':(location.riskAssessment==riskAssessmentStatusEnum.Risk), 'no-risk-computed':(location.riskAssessment==riskAssessmentStatusEnum.NoRisk)}">

                            </span>
                            <span [ngSwitch]="location.riskAssessment" style="vertical-align:text-bottom">
                                <span *ngSwitchCase="riskAssessmentStatusEnum.Risk">
                                    <b>Risiko</b>
                                </span>
                                <span *ngSwitchCase="riskAssessmentStatusEnum.NoRisk">Ingen risiko</span>
                            </span>
                        </td>

                        <td class="text-muted">{{location.calculationDate | date:'d/M/yyyy HH:mm'}}</td>

                        <td>
                            <span *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations && isScreening(location)" class="text-muted">
                                <i class="fa fa-cog"></i>
                                <span *ngIf="location.caseWorker"> {{location.caseWorker?.name}} (Omdømt)</span>
                                <span *ngIf="!location.caseWorker"> Automatisk screening</span>
                            </span>
                            <span *ngIf="showRiskCalculationMode === ViewCalculationMode.ShowAllCalculations && !isScreening(location) && location.caseWorker">
                                <i class="fa fa-user"></i> {{location.caseWorker?.name}}
                            </span>
                        </td>
                    </ng-container>
                </tr>
                </tbody>
            </table>

            <div class="text-center" *ngIf="!isContinuing && hasMoreSearchResults">
                <a href="javascript:void(0)" (click)="getMoreResults()">Hent flere resultater</a>
            </div>
            <div class="text-center" *ngIf="isContinuing">
                <p class="text-muted"><i class="fa fa-spinner fa-spin"></i> Henter lokaliteter</p>
            </div>
            </div>
        </div>
    </div>
</div>
